export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-inner">
          <div className="footer-left">
            <img src="/icon.png" alt="SyncroX" className="footer-logo-img" />
            <span className="footer-copy">&copy; 2025 SyncroX. Certifikovaný partner Money S3.</span>
          </div>
          <div className="footer-links">
            <a href="#">Ochrana osobních údajů</a>
            <a href="#">Obchodní podmínky</a>
            <a href="#">Podpora</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
